import { Box } from '@mui/material';
import { keyframes } from '@mui/material/styles';

const coolBlobAnimation = keyframes`
  0%, 100% {
    transform: translate(-30px, -20px) scale(1) translateZ(0);
    opacity: 0.15;
  }
  50% {
    transform: translate(20px, 50px) scale(1.15) translateZ(0);
    opacity: 0.35;
  }
`;

const warmBlobAnimation = keyframes`
  0%, 100% {
    transform: translate(30px, 20px) scale(1.1) translateZ(0);
    opacity: 0.15;
  }
  50% {
    transform: translate(-20px, -50px) scale(1.25) translateZ(0);
    opacity: 0.4;
  }
`;

export const DriveBackground = () => (
  <Box
    aria-hidden='true'
    data-testid='drive-background'
    sx={{
      position: 'absolute',
      inset: 0,
      backgroundColor: 'drive.backgroundLight',
      overflow: 'hidden',
      pointerEvents: 'none',
      zIndex: 0,
    }}
  >
    {/* Cool blob: top-left, blue/cyan */}
    <Box
      sx={{
        position: 'absolute',
        top: '-25%',
        left: '-15%',
        width: 1100,
        height: 1100,
        borderRadius: '50%',
        filter: 'blur(120px)',
        background:
          'radial-gradient(circle, rgba(0,210,255,0.4) 0%, rgba(84,100,255,0.25) 45%, transparent 70%)',
        animation: `${coolBlobAnimation} 14s ease-in-out infinite`,
        willChange: 'transform, opacity',
        backfaceVisibility: 'hidden',
        '@media (prefers-reduced-motion: reduce)': {
          animation: 'none',
        },
      }}
    />

    {/* Warm blob: bottom-right, magenta/purple */}
    <Box
      sx={{
        position: 'absolute',
        bottom: '-30%',
        right: '-20%',
        width: 1200,
        height: 1200,
        borderRadius: '50%',
        filter: 'blur(140px)',
        background:
          'radial-gradient(circle, rgba(255,0,210,0.4) 0%, rgba(136,80,255,0.25) 45%, transparent 75%)',
        animation: `${warmBlobAnimation} 18s ease-in-out infinite`,
        willChange: 'transform, opacity',
        backfaceVisibility: 'hidden',
        '@media (prefers-reduced-motion: reduce)': {
          animation: 'none',
        },
      }}
    />

    {/* Diagonal gradient overlay */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background:
          'linear-gradient(to bottom right, rgba(0,210,255,0.1), transparent, rgba(255,0,210,0.1))',
        pointerEvents: 'none',
      }}
    />

    {/* White wash overlay */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(255,255,255,0.1)',
        pointerEvents: 'none',
      }}
    />
  </Box>
);
